import _regeneratorRuntime from "babel-runtime/regenerator";
import _Object$assign from "babel-runtime/core-js/object/assign";
import _asyncToGenerator from "babel-runtime/helpers/asyncToGenerator";


import * as utils from "@/tools/util";
import bizPublicSaveMethod from "@/business/businessTools/bizPublicSaveMethod.js";
import bizOtherLinkInfoNode from "./bizOtherLinkInfoNode";

var GROUP_ID = "";

var MODULE_ID = "";

var SAVE_PATH = "";
var SAVE_PATH2 = "";

var backfillOldData = function backfillOldData(_this) {
  var otherlegelInfo = _.get(_this, "oppBusiData.oldBusiData.otherlegelInfo");
  if (!_.isEmpty(otherlegelInfo)) {
    _this.$blMethod.parseGroupsMouduleData(_this, [MODULE_ID], otherlegelInfo);
  }
};

var backfillHistoryData = function backfillHistoryData(_this) {
  var otherlegelInfo = _.cloneDeep(_.get(_this.historyData, SAVE_PATH));
  var otherlegelInfo2 = _.cloneDeep(_.get(_this.historyData, SAVE_PATH2));
  if (!_.isEmpty(otherlegelInfo)) {
    _this.$blMethod.parseGroupsMouduleData(_this, [MODULE_ID], otherlegelInfo);
    _this.$blMethod.parseGroupsMouduleDataSource(_this, [MODULE_ID], otherlegelInfo);
  }
  if (!_.isEmpty(otherlegelInfo2)) {
    _this.$blMethod.parseGroupsMouduleData(_this, [MODULE_ID], otherlegelInfo2);
    _this.$blMethod.parseGroupsMouduleDataSource(_this, [MODULE_ID], otherlegelInfo2);
  }
};

var setFeildData = function setFeildData(fieldData, fieldAction, val, filterArr) {
  _.each(fieldData, function (item) {
    if (filterArr.indexOf(item.FIELD_ID) == -1) {
      item[fieldAction] = val;
    };
  });
};

var setFeildNull = function setFeildNull(fieldData, filterArr) {
  _.each(fieldData, function (item) {
    if (filterArr.indexOf(item.FIELD_ID) == -1) {
      item.DEFAULT_VALUE == "";
    };
  });
};

var initFieldConfig = function initFieldConfig(_this) {
  var fields = _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS;

  fields.LEGAL_REP_POSITION_PATION.VALID_TYPE = "valAX[0, 512]";
  fields.LEGAL_REP_POSITION.FIELD_CONTROL = "1";
  fields.LEGAL_REP.VALID_TYPE = "val[4, 32]";
  fields.IS_SAME_AGENT.FIELD_TYPE = "radio";
  fields.IS_SAME_AGENT.DEFAULT_VALUE = "0";
  fields.LEGAL_PERSON_TEL.FIELD_TYPE = "telephone";
  fields.LEGAL_PERSON_TEL.telPhoneType = "1";
  fields.LEGAL_PERSON_TEL.VALID_TYPE = "tel";
  fields.LEGAL_REP.FIELD_TITLE = "姓名";
  fields.LEGAL_REP_ID_TYPE.FIELD_DICT_NAME = _.filter(fields.LEGAL_REP_ID_TYPE.FIELD_DICT_NAME, function (item) {
    return _this.oppBusiData.EFFECT_ID_TYPE.includes(item.DICT_ITEM) && item.DICT_ITEM[0] == "0";
  });
};

var NODE = {
  getGroupId: function getGroupId() {
    return GROUP_ID;
  },

  getModuleId: function getModuleId() {
    return MODULE_ID;
  },

  init: function init(_this) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    GROUP_ID = params.groupId;
    MODULE_ID = params.moduleId;
    SAVE_PATH = params.savePath;
    SAVE_PATH2 = params.savePath2;
  },

  beforeLoadBiz: function beforeLoadBiz(_this) {

    initFieldConfig(_this);

    if (_this.$storage.getJsonSession(_this.$definecfg.IS_OPEN_ACCT_BIZ) == 0) {
      backfillOldData(_this);
    }
  },

  afterLoadBiz: function afterLoadBiz(_this) {
    backfillHistoryData(_this);
  },

  beforeSave: function () {
    var _ref = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(_this, params) {
      var legalRepInfo, oldLegalLinkInfo, oldLegalLinkInfo2, IS_SAME_AGENT;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              legalRepInfo = bizPublicSaveMethod.getModuleObjctFoyKey(_this, MODULE_ID, [SAVE_PATH], true);
              oldLegalLinkInfo = _.get(params, "" + SAVE_PATH);
              oldLegalLinkInfo2 = _.get(params, "" + SAVE_PATH2);
              IS_SAME_AGENT = legalRepInfo.IS_SAME_AGENT;

              delete legalRepInfo["IS_SAME_AGENT"];

              legalRepInfo["LEGAL_EMAIL"] = "";

              legalRepInfo["LEGAL_REP_TYPE"] = "";

              if (IS_SAME_AGENT === "1") {
                params.IS_AGENT = "0";
              } else {
                params.IS_AGENT = "1";
              }

              bizPublicSaveMethod.getModuleUpdateFlagByPaths(_this, [SAVE_PATH], legalRepInfo);

              _.set(params, SAVE_PATH, _Object$assign({}, oldLegalLinkInfo, legalRepInfo));

              _.set(params, SAVE_PATH2, _Object$assign({}, oldLegalLinkInfo2, { IS_SAME_AGENT: IS_SAME_AGENT }));

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function beforeSave(_x2, _x3) {
      return _ref.apply(this, arguments);
    }

    return beforeSave;
  }(),

  validate: function () {
    var _ref2 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee2(_this) {
      var fields, data, agentfields, tempIdType, res;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              fields = _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS;
              data = void 0;

              if (fields.IS_SAME_AGENT.DEFAULT_VALUE == "1") {
                data = {
                  ID_CODE: _this.groupDatas.OCR_ORG_INFO_PAGE.IMPORTANT_MODULE[0].FIELDS.ID_CODE.DEFAULT_VALUE,
                  LEGAL_REP: _this.groupDatas.OCR_AGENT_INFO_PAGE.AGENT_MODULE[0].FIELDS.AGENT_USER_FNAME.DEFAULT_VALUE };
              } else {
                data = {
                  ID_CODE: _this.groupDatas.OCR_ORG_INFO_PAGE.IMPORTANT_MODULE[0].FIELDS.ID_CODE.DEFAULT_VALUE,
                  LEGAL_REP: _this.groupDatas.OTHER_INFO_PAGE.LEGAL_MODULE[0].FIELDS.LEGAL_REP.DEFAULT_VALUE
                };
              }

              agentfields = this.groupDatas.OCR_AGENT_INFO_PAGE.AGENT_MODULE[0].FIELDS;

              if (!(fields.IS_SAME_AGENT.DEFAULT_VALUE == "0" && fields.LEGAL_REP.DEFAULT_VALUE == agentfields.AGENT_USER_FNAME.DEFAULT_VALUE && fields.LEGAL_REP_ID_CODE.DEFAULT_VALUE == agentfields.AGENT_ID_CODE.DEFAULT_VALUE && fields.LEGAL_REP_ID_TYPE.DEFAULT_VALUE == agentfields.AGENT_ID_TYPE.DEFAULT_VALUE)) {
                _context2.next = 8;
                break;
              }

              if (!(fields.LEGAL_REP_ID_EXP_DATE.DEFAULT_VALUE !== agentfields.AGENT_ID_EXP_DATE.DEFAULT_VALUE)) {
                _context2.next = 8;
                break;
              }

              _this.alert("代理人与法定代表人证件信息一致时，证件有效期应保持一致！");
              return _context2.abrupt("return", false);

            case 8:
              tempIdType = _this.groupDatas["OCR_ORG_INFO_PAGE"]["IMPORTANT_MODULE"][0].FIELDS.ID_TYPE.DEFAULT_VALUE;

              if (!(tempIdType == "10")) {
                _context2.next = 16;
                break;
              }

              _this.$store.commit(_this.$types.UPDATE_LOADING, true);
              _context2.next = 13;
              return _this.$syscfg.K_Request("F0000059", data);

            case 13:
              res = _context2.sent;

              if (res.Code == "0") {
                if (res.Data[0].repeatFlag == 1) {
                  _this.oppBusiData.validateResArr.push({
                    alertType: "confirm",
                    messageText: "所录入的法定代表人/执行事务合伙人信息与工商系统不一致，请通过“国家企业信用信息公示系统”网站进行核实。"
                  });
                } else if (res.Data[0].repeatFlag == 2) {
                  _this.oppBusiData.validateResArr.push({
                    alertType: "confirm",
                    messageText: "\u8425\u4E1A\u6267\u7167\u53F7[" + data.ID_CODE + "]\u7684\u6CD5\u5B9A\u4EE3\u8868\u4EBA/\u6267\u884C\u4E8B\u52A1\u5408\u4F19\u4EBA\u4FE1\u606F\u5728\u5DE5\u5546\u7CFB\u7EDF\u4E0D\u5B58\u5728\uFF0C\u8BF7\u901A\u8FC7\u201C\u56FD\u5BB6\u4F01\u4E1A\u4FE1\u7528\u4FE1\u606F\u516C\u793A\u7CFB\u7EDF\u201D\u7F51\u7AD9\u8FDB\u884C\u6838\u5B9E\u3002"
                  });
                }
              }
              _this.$store.commit(_this.$types.UPDATE_LOADING, false);

            case 16:
              if (_this.$blMethod.validateLegalTel(_this, _this.groupDatas.OTHER_INFO_PAGE.LEGAL_MODULE[0].FIELDS)) {
                _context2.next = 18;
                break;
              }

              return _context2.abrupt("return", false);

            case 18:
              return _context2.abrupt("return", true);

            case 19:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function validate(_x4) {
      return _ref2.apply(this, arguments);
    }

    return validate;
  }(),

  pageActivated: function pageActivated(_this, groupId) {
    for (var mdId in _this.moduleDatas) {
      var md = _this.moduleDatas[mdId][0];
      var fieldData = md.FIELDS;
      var field = fieldData.IS_SAME_AGENT;
      _this.busiLogic.CHECK_IS_SAME_AGENT(_this, field, fieldData, md, true);
    }
  },
  afterSave: function afterSave(_this, newData) {},
  beforeSkipBiz: function beforeSkipBiz(_this) {},
  "CHECK_IS_SAME_AGENT": function CHECK_IS_SAME_AGENT(_this, field, fieldData, md, noClean) {
    if (md != null) {
      if (md.MODULE_ID == "LINK_MODULE") {
        if (field.DEFAULT_VALUE == "1") {
          setFeildData(fieldData, "FIELD_CONTROL", "1", ["IS_SAME_AGENT", "OFFICE_TEL", "EMAIL", "FAX"]);
          fieldData.LINKMAN.DEFAULT_VALUE = _this.groupDatas.OCR_AGENT_INFO_PAGE.AGENT_MODULE[0].FIELDS.AGENT_USER_FNAME.DEFAULT_VALUE;
          _this.$nextTick(function () {
            fieldData.LINKMAN_ID.DEFAULT_VALUE = _this.groupDatas.OCR_AGENT_INFO_PAGE.AGENT_MODULE[0].FIELDS.AGENT_ID_CODE.DEFAULT_VALUE;
          });
          fieldData.LINKMAN_ID_TYPE.DEFAULT_VALUE = _this.groupDatas.OCR_AGENT_INFO_PAGE.AGENT_MODULE[0].FIELDS.AGENT_ID_TYPE.DEFAULT_VALUE;

          if (fieldData.LINKMAN_EXP_DATE) {
            fieldData.LINKMAN_EXP_DATE.DEFAULT_VALUE = _this.groupDatas.OCR_AGENT_INFO_PAGE.AGENT_MODULE[0].FIELDS.AGENT_ID_EXP_DATE.DEFAULT_VALUE;
          }
          if (fieldData.LINKMAN_SEX) {
            fieldData.LINKMAN_SEX.DEFAULT_VALUE = _this.groupDatas.OCR_AGENT_INFO_PAGE.AGENT_MODULE[0].FIELDS.AGENT_SEX.DEFAULT_VALUE;
          }

          fieldData.LINKMAN.DATA_SOURCE = _this.groupDatas.OCR_AGENT_INFO_PAGE.AGENT_MODULE[0].FIELDS.AGENT_USER_FNAME.DATA_SOURCE;
          fieldData.LINKMAN_ID.DATA_SOURCE = _this.groupDatas.OCR_AGENT_INFO_PAGE.AGENT_MODULE[0].FIELDS.AGENT_ID_CODE.DATA_SOURCE;
          fieldData.LINKMAN_ID_TYPE.DATA_SOURCE = _this.groupDatas.OCR_AGENT_INFO_PAGE.AGENT_MODULE[0].FIELDS.AGENT_ID_TYPE.DATA_SOURCE;
          fieldData.LINKMAN_TEL.DEFAULT_VALUE = _this.groupDatas.OTHER_INFO_PAGE.AGENT_LINK_MODULE[0].FIELDS.MOBILE_TEL.DEFAULT_VALUE;
        } else {
          setFeildData(fieldData, "FIELD_CONTROL", "0", ["IS_SAME_AGENT"]);
          noClean == "0" && _this.$blMethod.parsefieldsDefaultValueToNull(md, ["IS_SAME_AGENT", "OFFICE_TEL", "EMAIL", "FAX"]);
        }
      }

      if (md.MODULE_ID == "LEGAL_MODULE") {
        if (field.DEFAULT_VALUE != "") {
          if (field.DEFAULT_VALUE == "1") {
            setFeildData(fieldData, "FIELD_CONTROL", "1", ["IS_SAME_AGENT", "LEGAL_MOBILE_TEL", "LEGAL_PERSON_TEL"]);
            fieldData.LEGAL_REP_POSITION.DEFAULT_VALUE = "";
            fieldData.LEGAL_REP.DEFAULT_VALUE = _this.groupDatas.OCR_AGENT_INFO_PAGE.AGENT_MODULE[0].FIELDS.AGENT_USER_FNAME.DEFAULT_VALUE;
            _this.$nextTick(function () {
              fieldData.LEGAL_REP_ID_CODE.DEFAULT_VALUE = _this.groupDatas.OCR_AGENT_INFO_PAGE.AGENT_MODULE[0].FIELDS.AGENT_ID_CODE.DEFAULT_VALUE;
            });
            fieldData.LEGAL_REP_ID_EXP_DATE.DEFAULT_VALUE = _this.groupDatas.OCR_AGENT_INFO_PAGE.AGENT_MODULE[0].FIELDS.AGENT_ID_EXP_DATE.DEFAULT_VALUE;
            fieldData.LEGAL_REP_ID_TYPE.DEFAULT_VALUE = _this.groupDatas.OCR_AGENT_INFO_PAGE.AGENT_MODULE[0].FIELDS.AGENT_ID_TYPE.DEFAULT_VALUE;

            fieldData.LEGAL_REP.DATA_SOURCE = _this.groupDatas.OCR_AGENT_INFO_PAGE.AGENT_MODULE[0].FIELDS.AGENT_USER_FNAME.DATA_SOURCE;
            fieldData.LEGAL_REP_ID_CODE.DATA_SOURCE = _this.groupDatas.OCR_AGENT_INFO_PAGE.AGENT_MODULE[0].FIELDS.AGENT_ID_CODE.DATA_SOURCE;
            fieldData.LEGAL_REP_ID_EXP_DATE.DATA_SOURCE = _this.groupDatas.OCR_AGENT_INFO_PAGE.AGENT_MODULE[0].FIELDS.AGENT_ID_EXP_DATE.DATA_SOURCE;
            fieldData.LEGAL_REP_ID_TYPE.DATA_SOURCE = _this.groupDatas.OCR_AGENT_INFO_PAGE.AGENT_MODULE[0].FIELDS.AGENT_ID_TYPE.DATA_SOURCE;
          } else {
            setFeildData(fieldData, "FIELD_CONTROL", "0", ["IS_SAME_AGENT", "LEGAL_REP_POSITION_PATION", "LEGAL_REP_POSITION"]);
            if (fieldData.LEGAL_REP_POSITION.DEFAULT_VALUE == "Z") {
              fieldData.LEGAL_REP_POSITION_PATION.FIELD_CONTROL = "0";
            }
            noClean == "0" && _this.$blMethod.parsefieldsDefaultValueToNull(md, ["IS_SAME_AGENT"]);
          }
        }
      }
    }
  },
  "CHECK_LEGAL_REP_POSITION": function CHECK_LEGAL_REP_POSITION(_this, field, fieldData) {
    if (field.DEFAULT_VALUE != "") {
      if (field.DEFAULT_VALUE == "Z") {
        fieldData.LEGAL_REP_POSITION_PATION.FIELD_CONTROL = "0";
      } else {
        fieldData.LEGAL_REP_POSITION_PATION.FIELD_CONTROL = "1";
      }
    }
  },
  "CHECK_LEGAL_REP_ID_TYPE": function CHECK_LEGAL_REP_ID_TYPE(_this, field, fieldData) {
    fieldData["LEGAL_REP_ID_CODE"] && (fieldData["LEGAL_REP_ID_CODE"].VALID_TYPE = _this.$blMethod.getIdCodeValidType(field.DEFAULT_VALUE));
    fieldData["LEGAL_REP_ID_CODE"].DEFAULT_VALUE = "";
  },
  CHECK_LEGAL_REP_ID_CODE: function CHECK_LEGAL_REP_ID_CODE(_this, field, fieldData) {
    if (field.LAST_DEFAULT_VALUE == field.DEFAULT_VALUE) {
      return;
    }
    field.LAST_DEFAULT_VALUE = field.DEFAULT_VALUE;
    field.DEFAULT_VALUE && _this.$blMethod.isDisabledLongTime(_this, fieldData.LEGAL_REP_ID_TYPE.DEFAULT_VALUE, field.DEFAULT_VALUE, fieldData.LEGAL_REP_ID_EXP_DATE);
  }
};

export default NODE;


//////////////////
// WEBPACK FOOTER
// ./src/business/businessFile/QS420/bizOther/bizOtherLegalInfoNode.js
// module id = 155
// module chunks = 2